import { Link, useNavigate } from "react-router-dom";
import React, { useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";

import avatar1 from "../../assets/images/user/avatar-1.jpg";

import ThemeDropdown from "./components/ThemeDropdown";
import { AuthContext } from "../../context/AuthContext";
import { handleLanguageChange } from "../../locales/i18n";

interface HeaderProps {
  themeMode?: string; // Define the type for themeMode
  changeThemeMode?: any; // Define the type for changeThemeMode function
  toogleSidebarHide?: () => void;
  toogleMobileSidebarHide?: () => void;
}

const TopBar = ({
  changeThemeMode,
  toogleSidebarHide,
  toogleMobileSidebarHide,
}: HeaderProps) => {
  const dispatch = useDispatch<any>();

  const auth = useContext(AuthContext);
  const { user, logout } = auth;
  const navigate = useNavigate();
  const { t } = useTranslation(); // Access the translation function

  // Function to handle theme mode change
  const handleThemeChange = (value: any) => {
    dispatch(changeThemeMode(value));
  };

  return (
    <React.Fragment>
      <header className="pc-header">
        <div className="header-wrapper">
          <div className="ms-auto">
            <ul className="list-unstyled">
              <li className="pc-h-item d-md-inline-flex dropdown">
                <a
                  className="pc-head-link arrow-none me-0 dropdown-toggle"
                  id="react-home-:r2:"
                  href="https://testing.rimagic.com"
                  role="button"
                  target="_blank"
                >
                  <i className="ph-duotone ph-house-line"></i>
                </a>
              </li>
              <ThemeDropdown />

              <Dropdown as="li" className="pc-h-item d-none d-md-inline-flex">
                <Dropdown.Toggle
                  as="a"
                  className="pc-head-link head-link-primary dropdown-toggle arrow-none me-0"
                  data-bs-toggle="dropdown"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <i className="ph-duotone ph-translate"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end pc-h-dropdown lng-dropdown">
                  {[
                    {
                      code: "en",
                      name: t("language.english"),
                      description: t("language.uk"),
                    },
                    {
                      code: "de",
                      name: t("language.german"),
                      description: t("language.germany"),
                    },
                  ].map((lang) => (
                    <Dropdown.Item
                      key={lang.code}
                      href="#!"
                      onClick={() => handleLanguageChange(lang.code)} // Change language
                    >
                      <span>
                        {lang.name} <small>({lang.description})</small>
                      </span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="pc-h-item">
                <Link
                  className="pc-head-link pct-c-btn"
                  to="/settings"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvas_pc_layout"
                >
                  <i className="ph-duotone ph-gear-six"></i>
                </Link>
              </div>

              <Dropdown as="li" className="pc-h-item header-user-profile">
                <Dropdown.Toggle
                  className="pc-head-link arrow-none me-0"
                  data-bs-toggle="dropdown"
                  href="#"
                  aria-haspopup="false"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                  style={{ border: "none" }}
                >
                  <img
                    src={user?.profilePicture?.path || avatar1}
                    alt={t("topbar.userImageAlt")}
                    width={40}
                    className="user-avtar wid-40 hei-40 object-fit-cover rounded-circle"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                  <div className="dropdown-header d-flex align-items-center justify-content-between">
                    <h4 className="m-0">{t("topbar.profile")}</h4>
                  </div>
                  <div className="dropdown-body">
                    <SimpleBar
                      className="profile-notification-scroll position-relative"
                      style={{ maxHeight: "calc(100vh - 225px)" }}
                    >
                      <ul className="list-group list-group-flush w-100">
                        <li
                          className="list-group-item"
                          role="button"
                          onClick={() => navigate("/profile-overview")}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                src={user?.profilePicture?.path || avatar1}
                                alt={t("topbar.userImageAlt")}
                                width={50}
                                className="wid-50 hei-50 object-fit-cover rounded-circle"
                              />
                            </div>
                            <div className="flex-grow-1 mx-3">
                              <h5 className="mb-0">
                                {user?.firstName + " " + user?.lastName}
                              </h5>
                              <a
                                className="link-primary"
                                href={`mailto:${user?.email}`}
                              >
                                {user?.email}
                              </a>
                            </div>
                          </div>
                        </li>
                        <li className="list-group-item">
                          <Dropdown.Item
                            onClick={() => navigate("/change-password")}
                          >
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-key"></i>
                              <span>{t("topbar.changePassword")}</span>
                            </span>
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => navigate("/personal-info")}
                          >
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-user-circle"></i>
                              <span>{t("topbar.editProfile")}</span>
                            </span>
                          </Dropdown.Item>
                          {/* <Dropdown.Item onClick={() => navigate("/settings")}>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-gear-six"></i>
                              <span>{t("topbar.settings")}</span>
                            </span>
                          </Dropdown.Item> */}
                        </li>
                        <li className="list-group-item">
                          <Dropdown.Item onClick={logout}>
                            <span className="d-flex align-items-center">
                              <i className="ph-duotone ph-power"></i>
                              <span>{t("topbar.logout")}</span>
                            </span>
                          </Dropdown.Item>
                        </li>
                      </ul>
                    </SimpleBar>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default TopBar;
